import React from "react";
import { weglotNoTranslationClassName } from "@stadium/constants";

const WeglotNoTranslationWrapper = ({
  children,
  className = "",
  enclosingElement: Component = "span",
}) => <Component className={`${weglotNoTranslationClassName} ${className}`}>{children}</Component>;

export default WeglotNoTranslationWrapper;
